import { DeliveryNoteContext, generateDeliveryNotePdf } from './deliveryNoteUtils';

type DownloadDeliveryNotePdfParams = {
  context: DeliveryNoteContext;
  translations: (key: string) => string;
};

export const downloadDeliveryNotePdf = async ({ context, translations }: DownloadDeliveryNotePdfParams) => {
  await generateDeliveryNotePdf({
    context,
    translations,
  });
};
